import { RoutePanelName, RouteConfig, RouteName, ModuleName } from "./types";

export const ROUTES: Partial<Record<ModuleName, RouteConfig>> = {
  [ModuleName.Catalog]: RouteName.Catalog,
  [ModuleName.ProjectPanel]: RouteName.Main,
  [ModuleName.Style]: RouteName.Style,
  [ModuleName.StyleEditor]: RouteName.StyleEditor,
  [ModuleName.Dashboard]: {
    name: RouteName.Main,
    payload: {
      panel: [RoutePanelName.Dashboard, RoutePanelName.Presentation],
    },
  },
  [ModuleName.LayerConfiguration]: RouteName.LayerConfiguration,
  [ModuleName.ProjectConfiguration]: RouteName.ProjectConfiguration,
  [ModuleName.EqlQuery]: RouteName.EqlQuery,
  [ModuleName.SymbolLibrary]: RouteName.SymbolLibrary,
  [ModuleName.LayerList]: {
    name: RouteName.Main,
    default: true,
    payload: {
      panel: [RoutePanelName.Layers, RoutePanelName.Table],
    },
  },
  [ModuleName.Table]: {
    name: RouteName.Main,
    payload: {
      panel: RoutePanelName.Table,
    },
  },
  [ModuleName.Tools]: {
    name: RouteName.Main,
    payload: {
      panel: RoutePanelName.Tools,
    },
  },
  [ModuleName.Feedback]: RouteName.Feedback,
};
